import AnimatedImage from 'core-lib/components/AnimatedImage';
import formatCurrency from 'core-lib/utils/currency';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { Button } from 'ui-v2/components/Button';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import s from './SavingPopup.module.scss';

export const SavingPopup = ({ show, onClose, saved, points }) => {
  return (
    <Modal
      head={{
        show: true,
        onClose: onClose,
      }}
      show={show}
      rootStyle={{
        zIndex: 10,
      }}
    >
      <div className={s.root}>
        <AnimatedImage
          src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240102165726910860.png"
          className={s.icon}
        />
        <Typography
          label={`Save ${formatCurrency(saved)} using Park+ Petrol`}
          variant="label_1_bold"
        />
        <Typography
          label={`You will save additional ${formatCurrency(
            saved
          )} on this product using ${formatFuelBalance(points)}`}
          variant="body_3_regular"
          color="secondary"
          className={s.subheading}
        />
        <Button size="medium" variant='primary' label="Understood" fullWidth onClick={onClose} />
      </div>
    </Modal>
  );
};
